// extracted by mini-css-extract-plugin
export default {"content":"page_content__x5sRZ","footer":"page_footer__zW0Ov","link":"page_link__IVLs8"};